import { BookOpenIcon, ClipboardCheckIcon, ClipboardListIcon, LightbulbIcon, SearchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '150 Attività su Industria Mineraria e Risorse Minerali per la Classe',
    description: 'Attività pronte su risorse minerali, giacimenti, estrazione, trattamento, sicurezza e ambiente.',
    icon: ClipboardListIcon,
  },
  {
    number: '2',
    title: 'Raccolta di Verifiche su Industria Mineraria e Risorse Minerali',
    description: 'Domande a scelta multipla, vero/falso, risposte brevi e problemi, con soluzioni.',
    icon: ClipboardCheckIcon,
  },
  {
    number: '3',
    title: "100 Casi di Studio e Scenari Reali dell'Industria Mineraria",
    description: 'Scenari da discutere in classe su esplorazione, estrazione, sicurezza, ambiente e comunità.',
    icon: SearchIcon,
  },
  {
    number: '4',
    title: '50 Progetti e Sfide di Indagine su Miniere e Risorse Minerali',
    description: 'Progetti STEM per la classe con obiettivi, materiali, fasi e criteri di valutazione.',
    icon: LightbulbIcon,
  },
  {
    number: '5',
    title: "Guida del Docente a Concetti e Terminologia dell'Industria Mineraria",
    description: 'Glossario e guida concettuale con spiegazioni chiare ed esempi per la classe.',
    icon: BookOpenIcon,
  },
];
